import React from 'react';
import styled from 'styled-components';
import { CustomerPortalButtonType } from 'api/customer-portal/theme-api';
import {
  CpBody00Primary,
  CpBody01Secondary,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';
import { ButtonWrapper as ButtonWrapperAtom } from 'components/molecules/views/components';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper as CpSectionWrapperAtom } from '../../common';
import { CpFeatureSectionVariantWidgetProps } from '../types';
import { CtaButton } from './cp-feature-with-image-on-left';

const CpSectionWrapper = styled(CpSectionWrapperAtom)`
  min-height: 0 !important;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  overflow-y: hidden;
  gap: var(--cp-spacing-10);

  @media (max-width: 780px) {
    gap: var(--cp-spacing-07);
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const SectionWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--cp-spacing-05);

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  width: 50%;

  @media (max-width: 480px) {
    width: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-05);
`;

const ButtonWrapper = styled(ButtonWrapperAtom)`
  display: flex;
  flex-wrap: wrap;
  gap: var(--cp-spacing-05);
  width: 100%;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: var(--cp-spacing-03);
    width: 100%;
  }
`;

const Tagline = styled(CpBody00Primary)`
  font-weight: normal;
`;
const Heading = styled(CpHeading03Primary)``;
const Description = styled(CpBody01Secondary)`
  padding-bottom: var(--cp-spacing-08);
`;

export const CpFeatureWithImageOnRight: React.FC<CpFeatureSectionVariantWidgetProps> =
  ({ disabled, data, widget }) => {
    const background = useGetBackground(widget);

    return (
      <CpSectionWrapper
        paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
        isDisabled={disabled}
        background={background}
      >
        <Wrapper>
          <SectionWrapper>
            <ContentWrapper>
              <Tagline autoAdjustColor>{data?.tagline}</Tagline>
              <Heading autoAdjustColor>{data?.title}</Heading>
              <Description autoAdjustColor>{data?.description}</Description>
            </ContentWrapper>

            <ButtonWrapper>
              <CtaButton
                cpType={CustomerPortalButtonType.Primary}
                onClick={() => window.open(data?.primaryButtonLink)}
              >
                {data?.primaryButtonText}
              </CtaButton>
              <CtaButton
                cpType={CustomerPortalButtonType.Secondary}
                onClick={() => window.open(data?.secondaryButtonLink)}
              >
                {data?.secondaryButtonText}
              </CtaButton>
            </ButtonWrapper>
          </SectionWrapper>
          <ImageWrapper>
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img
              src={data?.image?.attachment?.location}
              alt={data?.image?.attachment?.name}
            />
          </ImageWrapper>
        </Wrapper>
      </CpSectionWrapper>
    );
  };
